const CONSTANTS = {
	JSON_URL: process.env.REACT_APP_JSON_URL || "",
	ENV: process.env.REACT_APP_ENVIRONMENT || "",
	BASE_DOMAIN: process.env.REACT_APP_BASE_DOMAIN || "",
	BASE_URL: process.env.REACT_APP_BASE_URL || "",
	PROJECT_SITE_UTL: process.env.REACT_APP_LINK || "",
	FB_SHARE_URL: process.env.REACT_APP_FB_SHARE_URL || "",
	MOBILE_SIZE_QUERY: "(max-width: 880px)",
	MAIN_PLAY_HREF: `${process.env.REACT_APP_BASE_DOMAIN || ""}/play`,
	MAIN_ACCOUNT_HREF: `${process.env.REACT_APP_BASE_DOMAIN || ""}`,
	IS_OFF_SEASON: JSON.parse(process.env.REACT_APP_OFFSEASON_STATE || "false") as boolean,
	BADGE_URL: process.env.REACT_APP_BADGE_URL || "",
	BETTING_COUNTRIES: ["US"],
	BETTING_STATES: ["ON"],
	SITE_URL: window.location.origin || "",
	SKIP_TRANSLATIONS:
		new URLSearchParams(window.location.search).get("skipTranslation") === "true",
	GAME_ID: "BeatTheStreak2022",
	EXIT_URL: "https://www.mlb.com/play",
};

export default CONSTANTS;
